export default {
    name: 'tooltip',
    wireup: {
        bind: function (el, binding) {
            el.setAttribute('data-tooltip', '')
            var container = el.ownerDocument.createElement('div')
            container.className = Object.keys(binding.modifiers).join(' ')
            container.setAttribute('data-tooltip-text', binding.value)
            el.appendChild(container)
        },
    },
}
